import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { useAccount } from '../../contexts/Account';
import ACSnackbar from '../ACSnackbar';
import { updateBannerText } from '../../services/company_services';

const UpdateBannerPopUp = (props) => {
  const { open, setOpen } = props;
  const { asLoggedUserDetails, accountDetails } = useAccount();
  const [bannerText, setBannerText] = useState(
    accountDetails.joinPageBannerText || ''
  );
  const [loading, setLoading] = useState(false);
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

  const handleCancel = () => {
    if (loading) return;
    setBannerText('');
    setOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateBannerText({
        CONTACT_ID: asLoggedUserDetails.userId,
        BANNER_TEXT: bannerText,
      });
      setBannerText('');
      setOpen(false);
    } catch (error) {
      console.error('Error updating bannerText:', error);
      setIsSnackbarVisible(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle fontSize="30px">Update Banner Text</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Enter your bannerText"
          type="text"
          fullWidth
          multiline
          rows={3}
          value={bannerText}
          onChange={(e) => setBannerText(e.target.value)}
          variant="outlined"
          inputProps={{
            maxLength: 150,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !bannerText.trim()}
        >
          Submit
        </Button>
      </DialogActions>
      <ACSnackbar
        onClose={() => setIsSnackbarVisible(false)}
        open={isSnackbarVisible}
        severity="error"
        text="Something went wrong creating the survey."
      />
    </Dialog>
  );
};

export default UpdateBannerPopUp;
